/* Atlas header (ported from ac-cat-v2 header.js): desktop mega menu, region switcher, mobile accordion menu,
   mobile search, plus the Pitch wiring: cart buttons open Pitch's cart drawer, the cart count follows cart:update,
   and --header-height tracks the header's height for sticky Atlas sections. */
(function () {
  if (window.__atlasHeader) return;
  window.__atlasHeader = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  function init() {
    const header = $('[data-header]');
    if (!header) return;

    /* ───────── Desktop mega menu ───────── */
    const tops = $$('[data-top]', header);
    const panels = $$('[data-panel]', header);

    function closeNav() {
      panels.forEach((p) => (p.hidden = true));
      tops.forEach((t) => t.classList.remove('is-open'));
    }
    function openNav(idx) {
      closeCur();
      panels.forEach((p) => (p.hidden = p.dataset.panel !== String(idx)));
      tops.forEach((t) => t.classList.toggle('is-open', t.dataset.top === String(idx)));
      // open on the first category that has items (a plain link like "Shop all" has no data-cat)
      const panel = $('[data-panel="' + idx + '"]', header);
      const first = panel && $('[data-cat]', panel);
      if (first) setCat(idx, first.dataset.cat);
    }
    function setCat(panelIdx, catIdx) {
      const panel = $('[data-panel="' + panelIdx + '"]', header);
      if (!panel) return;
      $$('[data-cat]', panel).forEach((c) => c.classList.toggle('is-on', c.dataset.cat === String(catIdx)));
      $$('[data-itemset]', panel).forEach((s) => (s.hidden = s.dataset.itemset !== String(catIdx)));
    }

    /* Hover intent: with a menu already open, switching to another top item (or category) waits a moment,
       so moving the mouse diagonally across Women on the way to the Men panel does not swap menus.
       Entering the open panel, or leaving that item first, cancels the switch. Clicks switch at once. */
    const SWITCH_DELAY = 220;
    let topTimer = null, catTimer = null;
    const isOpen = () => panels.some((p) => !p.hidden);
    function cancelTop() { clearTimeout(topTimer); topTimer = null; }
    function cancelCat() { clearTimeout(catTimer); catTimer = null; }
    function goTop(t) {
      if (t.hasAttribute('data-has-panel')) openNav(t.dataset.top);
      else { closeNav(); closeCur(); }
    }
    tops.forEach((t) => {
      t.addEventListener('mouseenter', () => {
        cancelTop();
        if (!isOpen() || t.classList.contains('is-open')) { goTop(t); return; }
        topTimer = setTimeout(() => goTop(t), SWITCH_DELAY);
      });
      t.addEventListener('mouseleave', cancelTop);
      t.addEventListener('focus', () => { cancelTop(); goTop(t); });
    });
    panels.forEach((panel) => {
      panel.addEventListener('mouseenter', cancelTop);
      $$('[data-cat]', panel).forEach((c) => {
        c.addEventListener('mouseenter', () => {
          cancelCat();
          catTimer = setTimeout(() => setCat(panel.dataset.panel, c.dataset.cat), c.classList.contains('is-on') ? 0 : 120);
        });
        c.addEventListener('mouseleave', cancelCat);
      });
      $$('.ah-mega__items', panel).forEach((col) => col.addEventListener('mouseenter', cancelCat));
    });
    $$('[data-nav-close]', header).forEach((el) => {
      el.addEventListener('mouseenter', closeNav);
      el.addEventListener('click', closeNav);
    });
    header.addEventListener('mouseleave', () => { cancelTop(); cancelCat(); closeNav(); });

    /* ───────── Currency switcher (Shopify Markets localization form) ───────── */
    const cur = $('[data-cur]', header);
    const curToggle = cur && $('[data-cur-toggle]', cur);
    const curList = cur && $('[data-cur-list]', cur);
    function closeCur() {
      if (!curList) return;
      curList.hidden = true;
      curToggle.setAttribute('aria-expanded', 'false');
    }
    if (cur) {
      curToggle.addEventListener('click', () => {
        const open = curList.hidden;
        closeNav();
        curList.hidden = !open;
        curToggle.setAttribute('aria-expanded', String(open));
        if (open) { const si = curList.querySelector('[data-region-search]'); if (si) setTimeout(() => si.focus(), 0); }
      });
      document.addEventListener('click', (e) => { if (!cur.contains(e.target)) closeCur(); });
    }
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { closeCur(); closeNav(); closeMnav(); }
    });

    /* ───────── Desktop search: icon that opens into the field ───────── */
    const search = $('[data-search]', header);
    if (search) {
      const sBtn = $('[data-search-toggle]', search);
      const sInput = $('input[type="search"]', search);
      const openSearch = () => {
        search.classList.add('is-open');
        sBtn.setAttribute('aria-expanded', 'true');
        sInput.tabIndex = 0;
        requestAnimationFrame(() => sInput.focus());
      };
      const closeSearch = (refocus) => {
        if (!search.classList.contains('is-open')) return;
        search.classList.remove('is-open');
        sBtn.setAttribute('aria-expanded', 'false');
        sInput.tabIndex = -1;
        if (refocus) sBtn.focus();
      };
      sBtn.addEventListener('click', openSearch);
      /* stays open while there's text; closes when focus leaves an empty field */
      sInput.addEventListener('blur', () => { setTimeout(() => { if (!sInput.value.trim() && !search.contains(document.activeElement)) closeSearch(false); }, 150); });
      sInput.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.stopPropagation(); sInput.value = ''; closeSearch(true); }
      });
      search.addEventListener('submit', (e) => { if (!sInput.value.trim()) { e.preventDefault(); sInput.focus(); } });
    }

    /* ───────── Mobile search ───────── */
    const msBtn = $('[data-msearch-toggle]', header);
    const ms = $('[data-msearch]', header);
    if (msBtn && ms) {
      msBtn.addEventListener('click', () => {
        ms.hidden = !ms.hidden;
        msBtn.setAttribute('aria-expanded', String(!ms.hidden));
        if (!ms.hidden) { const i = $('input', ms); if (i) i.focus(); }
      });
    }

    /* ───────── Mobile menu: accordion ───────── */
    const mnav = $('[data-mnav]');
    if (!mnav) return;
    const backBtn = $('[data-mnav-back]', mnav);
    const logo = $('[data-mnav-logo]', mnav);
    const foot = $('[data-mnav-foot]', mnav);

    function setAcc(btn, open) {
      btn.setAttribute('aria-expanded', String(open));
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.inert = !open;
    }
    function resetMnav() {
      $$('[data-macc-toggle]', mnav).forEach((b) => setAcc(b, false));
      if (logo) logo.hidden = false;
      if (backBtn) backBtn.hidden = true;
      if (foot) foot.hidden = false;
      const sc = $('.am__scroll', mnav);
      if (sc) sc.scrollTop = 0;
    }
    function openMnav() {
      resetMnav();
      mnav.hidden = false;
      document.body.classList.add('atlas-lock');
      document.documentElement.setAttribute('data-mnav', 'open');
    }
    function closeMnav() {
      if (!mnav || mnav.hidden) return;
      mnav.hidden = true;
      const rs = mnav.querySelector('[data-region-sheet]'); if (rs) rs.hidden = true;
      document.body.classList.remove('atlas-lock');
      document.documentElement.removeAttribute('data-mnav');
    }
    window.__atlasCloseMnav = closeMnav;

    $$('[data-mnav-open]').forEach((b) => b.addEventListener('click', openMnav));
    $$('[data-mnav-close]', mnav).forEach((b) => b.addEventListener('click', closeMnav));
    $$('[data-macc-toggle]', mnav).forEach((b) => {
      b.addEventListener('click', () => {
        const open = b.getAttribute('aria-expanded') !== 'true';
        /* one top item open at a time; its open categories close with it */
        const group = b.closest('[data-macc]');
        const siblings = group && group.parentElement ? $$(':scope > [data-macc] > [data-macc-toggle]', group.parentElement) : [];
        if (open) siblings.forEach((o) => { if (o !== b) $$('[data-macc-toggle]', o.closest('[data-macc]')).forEach((x) => setAcc(x, false)); });
        if (!open && group) $$('[data-macc-toggle]', group).forEach((o) => { if (o !== b) setAcc(o, false); });
        setAcc(b, open);
        /* bring the opened group into view once it has expanded */
        if (open && group && group.classList.contains('am__group')) {
          setTimeout(() => {
            const sc = $('.am__scroll', mnav);
            if (!sc) return;
            const top = group.getBoundingClientRect().top - sc.getBoundingClientRect().top;
            if (top < 0 || top > sc.clientHeight * 0.5) sc.scrollTo({ top: sc.scrollTop + top - 8, behavior: 'smooth' });
          }, 420);
        }
      });
    });

    // Region / currency sheet (mobile drawer footer)
    const sheet = $('[data-region-sheet]', mnav);
    const sheetOpen = $('[data-region-sheet-open]', mnav);
    if (sheet && sheetOpen) {
      sheetOpen.addEventListener('click', () => { sheet.hidden = false; const si = $('[data-region-search]', sheet); if (si) si.focus(); });
      $('[data-region-sheet-close]', sheet).addEventListener('click', () => { sheet.hidden = true; });
    }

    // Close the drawer if the viewport grows past the mobile breakpoint
    window.matchMedia('(min-width: 1200px)').addEventListener('change', (e) => { if (e.matches) closeMnav(); });
  }

  /* Cart buttons open Pitch's cart drawer (rendered inside the header), else go to the cart page */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cart-open]');
    if (!b) return;
    e.preventDefault();
    if (window.__atlasCloseMnav) window.__atlasCloseMnav();
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.href = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
  });

  /* Cart count sync on Pitch's cart:update event */
  document.addEventListener('cart:update', (e) => {
    const d = e.detail || {};
    let count = d.resource && typeof d.resource.item_count === 'number' ? d.resource.item_count : null;
    if (count === null && d.data && typeof d.data.itemCount === 'number') count = d.data.itemCount;
    if (count === null) return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  });

  /* Keep --header-height equal to the header's height (Atlas sections stick below it) */
  function trackHeight() {
    const h = document.querySelector('[data-header]');
    if (!h) return;
    const set = () => {
      const px = Math.round(h.getBoundingClientRect().height) + 'px';
      document.documentElement.style.setProperty('--header-height', px);
      document.body.style.setProperty('--header-height', px);
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(h);
    else window.addEventListener('resize', set);
  }

  function closeMnav() { if (window.__atlasCloseMnav) window.__atlasCloseMnav(); }
  function closeCur() {}
  function closeNav() {}

  function start() { init(); trackHeight(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
